import agentApi from "../apis/agentApi";

import { FETCH_EQUIPMENT_TYPES } from "./types";

export const fetchEquipmentTypes = () => async (dispatch) => {
  const response = await agentApi.get("/api/equipment");

  dispatch({ type: FETCH_EQUIPMENT_TYPES, payload: response.data });
};
